import { CarabinerIcon } from './CarabinerIcon';

/**
 * author: Google
 * id 077EABE1-1DBC-4AC9-AA0E-B45386391968
 * name carabiner
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/carabiner.svg
 * tags
 * - Sport 
 */
export const KarabinerIcon = CarabinerIcon;
export default KarabinerIcon